<template><NativeRouterLink v-bind="$attrs" :to="destination"><slot/></NativeRouterLink></template>
<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink as NativeRouterLink, useRouter, type RouteLocationRaw } from 'vue-router'
import { localizedPath } from '@/i18n'
defineOptions({ inheritAttrs: false })
const props = defineProps<{ to: RouteLocationRaw }>()
const router = useRouter()
const destination = computed(() => localizedPath(typeof props.to === 'string' ? props.to : router.resolve(props.to).fullPath))
</script>
